import {
  RESULT_TYPES,
  CELL_MERGE_SETTINGS,
  MATRIX_CELL_MERGE_SETTINGS,
} from '../questions.constants'

export function exportTable(XLSX, results) {
  const INDEX_HUMAN_OFFSET = 1

  const bookNew = XLSX.utils.book_new()

  results.forEach((result, groupIndex) => {
    result.questions.forEach((question, questionIndex) => {
      if (
        question.resultType !== RESULT_TYPES.MATRIX &&
        question.resultType !== RESULT_TYPES.LINEAR
      ) {
        return
      }

      const isMatrix = question.resultType === RESULT_TYPES.MATRIX

      const params = {
        question,
        bookNew,
        groupIndex,
        questionIndex,
        INDEX_HUMAN_OFFSET,
        XLSX,
      }

      isMatrix ? matrixTable(params) : linearTable(params)
    })
  })

  XLSX.writeFile(bookNew, 'data.xlsx')
}

function linearTable({
  question,
  bookNew,
  groupIndex,
  questionIndex,
  INDEX_HUMAN_OFFSET,
  XLSX,
}) {
  const json = question.results.map(element => ({
    option: element.label,
    percentage: element.percentage,
    count: element.count,
  }))

  let jsonToSheet = XLSX.utils.json_to_sheet(json, { origin: 2 })

  jsonToSheet = XLSX.utils.sheet_add_aoa(jsonToSheet, [[question.title]], {
    origin: 0,
  })

  jsonToSheet['!merges'] = CELL_MERGE_SETTINGS

  XLSX.utils.book_append_sheet(
    bookNew,
    jsonToSheet,
    `table-${groupIndex + INDEX_HUMAN_OFFSET}-${questionIndex + INDEX_HUMAN_OFFSET}`,
  )
}

function matrixTable({
  question,
  bookNew,
  groupIndex,
  questionIndex,
  INDEX_HUMAN_OFFSET,
  XLSX,
}) {
  question.results.forEach((resultMatrix, resultMatrixIndex) => {
    const json = resultMatrix.subAnswers.map(subAnswer => ({
      option: subAnswer.label,
      percentage: subAnswer.percentage,
      count: subAnswer.count,
    }))

    let jsonToSheetMatrix = XLSX.utils.json_to_sheet(json, { origin: 3 })

    jsonToSheetMatrix = XLSX.utils.sheet_add_aoa(jsonToSheetMatrix, [[question.title]], {
      origin: 0,
    })

    jsonToSheetMatrix = XLSX.utils.sheet_add_aoa(
      jsonToSheetMatrix,
      [[resultMatrix.label]],
      {
        origin: 1,
      },
    )

    jsonToSheetMatrix['!merges'] = MATRIX_CELL_MERGE_SETTINGS

    XLSX.utils.book_append_sheet(
      bookNew,
      jsonToSheetMatrix,
      `table-${groupIndex + INDEX_HUMAN_OFFSET}-${questionIndex +
        INDEX_HUMAN_OFFSET}-${resultMatrixIndex + INDEX_HUMAN_OFFSET}`,
    )
  })
}
